import type { Episode } from "@hybrid-iptv/types";
import { isResumable, useProgressStore } from "../library/progressStore.js";
import { episodeKey } from "../library/vodHooks.js";
import { usePlayerStore } from "./playerStore.js";

/**
 * Plays an episode the way the series page does (pages/SeriesPage.tsx handlePlayEpisode), for the
 * Play next card: the episode's own progress key, its label, and a resume if it was left part-way.
 * A free viewer's series allowance is checked by playSource, as for any episode.
 */
export async function playEpisode(seriesTitle: string, episode: Episode, providerId?: string): Promise<void> {
  const key = episodeKey(episode);
  const saved = useProgressStore.getState().get(key);
  const store = usePlayerStore.getState();
  store.setPlayingContent({ contentType: "episode", contentRef: key });
  const label = `${seriesTitle} S${episode.seasonNumber}E${episode.episodeNumber}`.trim();
  useProgressStore.getState().remember(key, {
    title: label,
    posterUrl: episode.stillUrl,
    url: episode.streamUrl,
    ...(providerId ? { series: { providerId, title: seriesTitle } } : {}),
  });
  await store.playSource({
    url: episode.streamUrl,
    type: "vod",
    title: label,
    artworkUrl: episode.stillUrl,
    ...(episode.media ? { media: episode.media } : {}),
  });
  if (isResumable(saved)) store.seek(saved!.positionSeconds);
}
